import { apiClass } from '@/base/class/api.class'
import { ENDPOINTS } from '@/base/const/endpoints.const'
import { ERROR_CODES_NAMES } from '@/base/const/errorCodes.const'

const state = {
  loading: false,
  errorHash: null,
  errorData: null,
}
const mutations = {
  SET_ERROR_LOADING(state, value) {
    state.loading = value
  },
  SET_ERROR_HASH(state, value) {
    state.errorHash = value
  },
  SET_ERROR_DATA(state, data) {
    state.errorData = data
  },
}
const actions = {
  getErrorTrxData({ commit, state }, { errorHash }) {
    commit('SET_ERROR_LOADING', true)
    commit('SET_ERROR_HASH', errorHash)
    const data = {
      hash: errorHash,
    }
    return apiClass
      .post(ENDPOINTS.error, data)
      .then((response) => {
        commit('SET_ERROR_DATA', response.body.data)
        return Promise.resolve()
      })
      .finally(() => {
        commit('SET_ERROR_LOADING', false)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
}
const getters = {
  isErrorDataSet(state) {
    return !!state.errorData
  },
  getErrorDataCode(state) {
    if (state.errorData) {
      return state.errorData.code || state.errorData.errorCode
    }
    return ERROR_CODES_NAMES.GENERAL_ERROR
  },
  /**
   * Status HTTP odpowiedzi, która doprowadziła do widoku błędu.
   *
   * `null` znaczy „serwer nie odpowiedział" - żądanie padło na sieci albo zostało przerwane.
   * Widoki wstawiają tę wartość przez `readHttpStatus` (`@/base/utils/errorData`); miejsca ustawiające
   * kod błędu **jawnie** (404, timeout sesji, błąd payway) statusu nie mają i nie potrzebują, bo ich
   * kod zawsze znajdzie definicję i nie trafia do raportowania.
   */
  getErrorDataHttpStatus(state) {
    const status = state.errorData?.errorStatus
    return typeof status === 'number' ? status : null
  },
  /**
   * Czy widok, który ustawił błąd, zaraportował już ten incydent sam.
   *
   * Ustawia to **wyłącznie** miejsce, które ma o incydencie więcej do powiedzenia niż widok błędu -
   * dziś tylko `SecureBack.vue` przy utracie parametrów powrotu z banku. Bez tego jedno zdarzenie
   * liczyło się dwa razy (`flow: secure-back` ORAZ `flow: error-view`, ~1550 zdarzeń na dobę duplikatu).
   *
   * Flaga celowo NIE jest „wycisz widok błędu": dotyczy pojedynczego commitu `SET_ERROR_DATA`, więc
   * odpowiedź 422 bez `errorCode` przy KOMPLETNYCH parametrach nadal zostanie zaraportowana - a to
   * właśnie ten przypadek jest realnym rozjazdem kontraktu.
   */
  isErrorAlreadyReported(state) {
    return state.errorData?.errorAlreadyReported === true
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
